import React from 'react'

const RaiseComplaintModal = props => {
  const { header, content, primaryButton, secondaryButton, successButton, type, heightFix } = props
  const secondaryButtonAction = () => {
    if (typeof secondaryButton.action === 'function') {
      secondaryButton.action()
    }
    // closeSubModal()
  }

  const primaryButtonAction = () => {
    if (typeof primaryButton.action === 'function') {
      primaryButton.action()
    }
  }

  const successButtonAction = () => {
    if (typeof successButton.action === 'function') {
      successButton.action()
    }
  }

  return (
    <React.Fragment>
      <div className={`${heightFix ? 'modal-box-case-full' : 'modal-box-case'}`}>
        <h6 className="modal-heading-case ta-c apt-10 apb-10 fw-500">
          <span className="fs-17 fw-600">{header}</span>
        </h6>
        <div className="modal-content-case ta-c apl-10 apr-10 lh-title fs-13">{content}</div>
        <If
          condition={
            (secondaryButton && secondaryButton.visible) ||
            (primaryButton &&
              primaryButton.visible &&
              (type === 'complaint' || type === 'callback_outbound'))
          }
        >
          <ul className="modal-actions-case flex flex-center">
            <If condition={secondaryButton.visible}>
              <li className="ta-c w-40p fw-700 br" onClick={secondaryButtonAction}>
                <button
                  type="button"
                  className="fw-700 fs-17 bn c-blue c-pointer tt-capitalize pr-6"
                >
                  {secondaryButton.text}
                </button>
              </li>
            </If>
            <If condition={primaryButton.visible}>
              <li className="ta-c w-40p c-blue fw-700" onClick={primaryButtonAction}>
                <button
                  type="button"
                  className="fw-700 fs-17 bn c-blue c-pointer tt-capitalize pl-6"
                >
                  {primaryButton.text}
                </button>
              </li>
            </If>
          </ul>
        </If>
        <If
          condition={
            successButton &&
            successButton.visible &&
            (type === 'fulfillment' ||
              type === 'processing' ||
              type === 'escalation' ||
              type === 'sos')
          }
        >
          <ul className="modal-actions-case flex flex-center">
            <li className="ta-c w-40p fw-700" onClick={successButtonAction}>
              <button type="button" className="fw-700 fs-17 bn c-pointer tt-capitalize c-blue">
                {successButton.text}
              </button>
            </li>
          </ul>
        </If>
      </div>
    </React.Fragment>
  )
}

export default RaiseComplaintModal
